import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-four-panel', COMPONENT );
} )( app );
